import { AuthScope } from '@/lib/useAuthScopes';
import { axiosV2 } from '@/main';

class UserWebserviceV2 {
    public getCompanies() {
        return axiosV2.get<{
            data: AuthScope[];
        }>('users/companies');
    }
}

export const userWebserviceV2 = new UserWebserviceV2();
